export default class Measurement {
	constructor(dto) {
		this.value = dto && typeof dto === 'object' && typeof dto.value === 'number' ? dto.value : 0;
		this.units = dto && typeof dto === 'object' && typeof dto.units === 'string' ? dto.units : '';
	}
}
